var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.9033V19.9033C20 18.8425 19.5786 17.825 18.8284 17.0749C18.0783 16.3247 17.0609 15.9033 16 15.9033H8C6.93913 15.9033 5.92172 16.3247 5.17157 17.0749C4.42143 17.825 4 18.8425 4 19.9033V21.9033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.9033C14.2091 11.9033 16 10.1125 16 7.90332C16 5.69418 14.2091 3.90332 12 3.90332C9.79086 3.90332 8 5.69418 8 7.90332C8 10.1125 9.79086 11.9033 12 11.9033Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.78ee2c8cff4a48dc2467414484c52b39.svg";
export { ForwardRef as ReactComponent };